export default {
    "citrixready.citrix.com" : {
        id: "UA-2429794-25",
        conversionsEnabled: false
    },
    "citrixreadyqa.citrix.com" : {
        id: "UA-2429794-27",
        conversionsEnabled: false
    },
    "localhost.citrix.com" : {
        id: "UA-2429794-27",
        conversionsEnabled: true
    },
    "www.citrix.com" : {
        id: "UA-2429794-25",
        conversionsEnabled: true
    },
    "stg-www.citrix.com" : {
        id: "UA-2429794-27",
        conversionsEnabled: true
    },
    "www.sharefile.com" : {
        id: "UA-142592-2",
        conversionsEnabled: false
    },
    "stg-www.sharefile.com" : {
        id: "UA-142592-24",
        conversionsEnabled: false
    }
}